<template>
  <div>
    <s-switch
      :id="id"
      v-model="input_data"
      v-bind="$attrs"
      v-on="$listeners"
      @input="input"
      v-if="!input_data && confirm === undefined"
    ></s-switch>
    <s-dropdown transfer v-model="visible" v-else>
      <s-switch id v-model="input_data" v-bind="$attrs" v-on="$listeners" @input="input"></s-switch>
      <div slot="content" class="confirm-role">
        <div class="mb-2">
          <span class="pl-1">
            <s-icon icon="question" class="red-text text-accent"></s-icon>
          </span>
          <span>{{ info }}</span>
        </div>
        <div class="text-center">
          <s-btn @click.native="cancel" size="small">Cancel</s-btn>
          <s-btn @click.native="run" class="mr-2" primary size="small">Confirm</s-btn>
        </div>
      </div>
    </s-dropdown>
  </div>
</template>

<script>
export default {
  name: 'switch-dropdown',
  props: {
    value: [Number, Boolean],
    info: {
      type: String,
      default() {
        return 'Are you sure?'
      },
    },
    confirm: String,
  },
  data() {
    return {
      input_data: this.value,
      visible: false,
      id: this.generateGuuId(),
    }
  },
  watch: {
    value(newValue) {
      this.input_data = newValue
    },
  },
  methods: {
    run() {
      this.visible = false
      this.input_data = Number(!this.input_data)
      this.input()
    },
    cancel() {
      this.visible = false
    },
    input(value) {
      this.$emit('input', this.input_data)
      this.$emit('change', this.input_data)
    },
  },
}
</script>
